export default "__VITE_ASSET__CGcCRwff__"